import { INVOICE_PAGE_SIZE_OPTIONS } from "@nlc/shared-types";
import { z } from "zod";

export const DEFAULT_INVOICE_PAGE_SIZE = INVOICE_PAGE_SIZE_OPTIONS[0];

const invoicePageSizeZod = z.coerce
  .number()
  .refine((value) =>
    (INVOICE_PAGE_SIZE_OPTIONS as readonly number[]).includes(value),
  );

export const invoicesSearchSchema = z.object({
  invoice: z.union([z.string(), z.number()]).transform(String).optional(),
  limit: invoicePageSizeZod
    .default(DEFAULT_INVOICE_PAGE_SIZE)
    .catch(DEFAULT_INVOICE_PAGE_SIZE),
  page: z.coerce.number().int().positive().default(1).catch(1),
});

export type InvoicesSearch = z.infer<typeof invoicesSearchSchema>;
